import actionType from './constant'

export const setMovies = (value) => ({
	type: actionType.SET_MOVIES,
	value,
});

export const clearMovies = () => ({
	type: actionType.CLEAR_MOVIES,
});